import React, { ReactNode } from 'react';
import ActivationHeader from './ActivationHeader';
import ActivationIds from './ActivationIds';
import ActivationPassword from './ActivationPassword';
import ActivationMail from './ActivationMail';
import AlmostDoneModal from '../accountCreation/components/AlmostDoneModal';
import { ActivationDTO } from '../../../network/api/types/activation/ActivationDTO';
import activationApi from '../../../network/api/activationApi';
import { toastError } from '../../common/Notification';
import Footer from '../../layout/Footer';
import ActivationDoublon from './ActivationDoublon';
import { PersonneActivationDedoublonnageDTO } from '../../../network/api/types/activation/PersonneActivationDedoublonnageDTO';

type Props = {
};

type State = {
  index: number;
  isAlmostDoneModal: boolean,
  activationDto: ActivationDTO;
  duplicateAccounts: PersonneActivationDedoublonnageDTO[],
  resizing: boolean,
  isLoading: boolean,
};

class AccountActivation extends React.Component<Props, State> {
  state: State = {
    index: 0,
    isAlmostDoneModal: false,
    activationDto: {},
    duplicateAccounts: [],
    resizing: false,
    isLoading: false,
  };

  animationdurantion = 400;

  minwidth = 33;

  maxpourcentage = 66;

  progressBarScroll = (): void => {
    setTimeout(() => {
      const winScroll = this.scrollableRef.current.scrollTop;
      const height = this.findPos(this.activationIdRef.current, 2);
      const scrolled = this.minwidth + (winScroll / height) * this.maxpourcentage;
      this.progressBarRef.current.style.width = `${scrolled}%`;
    }, this.animationdurantion);
  };

  resizePage = (): void => {
    if (!this.state.resizing) {
      this.setState({ resizing: true });
      setTimeout(() => {
        const height = `calc(100vh - ${this.headerRef.current ? this.headerRef.current.getBoundingClientRect().height : 130}px - ${this.footerRef.current ? this.footerRef.current.getBoundingClientRect().height : 37}px)`;
        this.scrollableRef.current.style.height = height;
        this.setState({ resizing: false });
      }, this.animationdurantion);
    }
  };

  componentDidMount(): void {
    this.scrollableRef.current.addEventListener('scroll', this.progressBarScroll);
    window.addEventListener('resize', this.resizePage);
  }

  componentWillUnmount(): void {
    this.scrollableRef.current.removeEventListener('scroll', this.progressBarScroll);
    window.removeEventListener('resize', this.resizePage);
  }

  headerRef = React.createRef<HTMLDivElement>();

  footerRef = React.createRef<HTMLElement>();

  scrollableRef = React.createRef<HTMLDivElement>();

  activationIdRef = React.createRef<HTMLDivElement>();

  activationMailRef = React.createRef<HTMLDivElement>();

  activationPasswordRef = React.createRef<HTMLDivElement>();

  activationDoublonRef = React.createRef<HTMLDivElement>();

  progressBarRef = React.createRef<HTMLDivElement>();

  findPos = (obj: HTMLDivElement, index: number): number => {
    const height = obj.getBoundingClientRect().height;
    return height * index;
  };

  goto = (index: number): void => {
    this.setState({ index },
      () => {
        if (this.scrollableRef.current.scroll) {
          this.scrollableRef.current.scroll({
            top: this.findPos(this.activationIdRef.current, index),
            behavior: 'smooth',
          });
        } else {
          // IE11
          this.scrollableRef.current.scrollTop = this.findPos(this.activationIdRef.current, index);
        }
      });
  };

  openAlmostDoneModal = (): void => {
    this.setState((prevState) => ({ isAlmostDoneModal: !prevState.isAlmostDoneModal }));
  };

  updateUserData = (values: ActivationDTO, index: number): ActivationDTO => {
    this.setState((previousState) => ({
      activationDto: {
        ...previousState.activationDto,
        ...values,
      },
    }));
    if (index !== null) {
      this.goto(index);
    }
    return {
      ...this.state.activationDto,
      ...values,
    };
  };

  onChange = (index: number): void => {
    if (index < this.state.index) {
      this.setState(() => ({ index }),
        () => {
          if (this.scrollableRef.current.scroll) {
            this.scrollableRef.current.scroll({
              top: this.findPos(this.activationIdRef.current, index),
              behavior: 'smooth',
            });
          } else {
            // IE11
            this.scrollableRef.current.scrollTop = this.findPos(
              this.activationIdRef.current, index,
            );
          }
        });
    }
  };

  findDuplicates = (values: ActivationDTO, index: number): void => {
    this.setState({ isLoading: true });
    const updatedUserData = this.updateUserData(values, null);
    activationApi.findDuplicates(updatedUserData)
      .then((response) => {
        this.setState({ isLoading: false });
        if (response.success && response.dtos && response.dtos.length > 0) {
          this.setState({ duplicateAccounts: response.dtos });
          this.goto(index);
        } else {
          this.endForm(updatedUserData);
        }
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        if (typeof e.then === 'function') {
          e.then((err) => {
            const error = err.fieldErrors ? err.fieldErrors[0].message : err.message;
            toastError(error);
          });
        }
      });
  };

  deleteDuplicates = (values: ActivationDTO): void => this.endForm(values);

  endForm = (values: ActivationDTO): void => {
    this.setState({ isLoading: true });
    const updatedUserData = this.updateUserData(values, null);
    activationApi.initActivationPro(updatedUserData)
      .then(() => {
        this.setState({ isLoading: false });
        this.openAlmostDoneModal();
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        if (typeof e.then === 'function') {
          e.then((err) => {
            const error = err.fieldErrors ? err.fieldErrors[0].message : err.message;
            toastError(error);
          });
        }
      });
  };

  render(): ReactNode {
    return (
      <div className="parcours">
        <ActivationHeader progressBarRef={this.progressBarRef} title="ACTIVATION.TITLE" percentOfStep={33} divRef={this.headerRef} index={this.state.index} />
        <AlmostDoneModal
          isOpen={this.state.isAlmostDoneModal}
          openModal={this.openAlmostDoneModal}
          email={this.state.activationDto.email}
          isCreation={false}
        />
        <div
          style={{ height: `calc(100vh - ${this.headerRef.current ? this.headerRef.current.getBoundingClientRect().height : 130}px - ${this.footerRef.current ? this.footerRef.current.getBoundingClientRect().height : 37}px)` }}
          ref={this.scrollableRef}
          className="activation-forms-container"
        >
          <div
            className={`variable-height height${this.state.index + 1}`}

          >
            <ActivationIds
              update={(values) => this.updateUserData(values, 1)}
              divRef={this.activationIdRef}
              onChange={this.onChange}
              initial={this.state.activationDto}
            />
            {this.state.index >= 1
            && (
            <ActivationPassword
              initial={this.state.activationDto}
              update={(values) => this.updateUserData(values, 2)}
              divRef={this.activationPasswordRef}
              suggestedPseudo={this.state.activationDto.pseudo}
              onChange={this.onChange}
            />
            )}
            {this.state.index >= 2
            && (
            <ActivationMail
              activation
              divRef={this.activationMailRef}
              endForm={(values) => this.findDuplicates(values, 3)}
              isLoading={this.state.isLoading}
              fromEnrolement={false}
            />
            )}
            {this.state.index >= 3
            && (
            <ActivationDoublon
              divRef={this.activationDoublonRef}
              isLoading={this.state.isLoading}
              duplicateAccounts={this.state.duplicateAccounts}
              endForm={this.deleteDuplicates}
            />
            )}
          </div>
        </div>
        <Footer footerRef={this.footerRef} />
      </div>
    );
  }
}

export default AccountActivation;
